import { render, staticRenderFns } from "./talentSendPlayerDetails.vue?vue&type=template&id=51225d0e&scoped=true&"
import script from "./talentSendPlayerDetails.vue?vue&type=script&lang=js&"
export * from "./talentSendPlayerDetails.vue?vue&type=script&lang=js&"
import style0 from "./talentSendPlayerDetails.vue?vue&type=style&index=0&id=51225d0e&lang=stylus&scoped=true&"
import style1 from "./talentSendPlayerDetails.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51225d0e",
  null
  
)

export default component.exports